export enum SourceType {
  national = 1,
  harvested = 2,
  wos = 3
}